import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Dev-only network debug helpers (keep imported so we can see failing Firestore REST calls)
import { enableNetworkDebug } from './debug/networkDebug';

// Enable in dev only
if (process.env.NODE_ENV !== 'production') {
  try { enableNetworkDebug(); } catch (e) { /* ignore */ }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
